import React, { useState, useEffect, useMemo, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { apiFetch } from "../../api";
import "./Pobotnica.css";
import { FiSearch, FiFilePlus, FiArrowLeft } from "react-icons/fi";

const zacetnoStanje = {
    stevilkaSpisaIzvrsitelja: "",
    izvrsitelj: "",
    naslovIzvrsitelja: "",
    gsmIzvrsitelja: "",
    ePostaIzvrsitelja: "",

    zadeva: "",
    opravilnaStevilkaSodisca: "",
    datumPrejema: "",
    datumPobotnice: "",

    placnik: "",
    opisPlacila: "",

    nazivUpnika: "",
    naslovUpnika: "",

    glavnica: "",
    obrestnaMera: "",
    obrestiOd: "",
    obrestiDo: "",
    znesekObresti: "",
    pravdniStroski: "",
    izvrsilniStroski: "",
    takse: "",
    drugaPostavkaETekst: "",
    drugaPostavkaEZnesek: "",
    drugaPostavkaFTekst: "",
    drugaPostavkaFZnesek: "",

    krajPodpisaStranke: "",
    krajPodpisaIzvrsitelja: "",
    datumPodpisaStranke: "",
    datumPodpisaIzvrsitelja: "",
};

function pretvoriZnesek(vrednost) {
    if (vrednost == null || vrednost === "") return 0;

    const str = String(vrednost).replace(/\s/g, "");
    let normalizirano = str;

    if (str.includes(",")) {
        normalizirano = str.replace(/\./g, "").replace(",", ".");
    } else if (str.includes(".")) {
        const dotIndex = str.indexOf(".");
        const decimals = str.length - dotIndex - 1;

        if (decimals === 3 && dotIndex <= str.length - 4) {
            normalizirano = str.replace(/\./g, "");
        }
    }

    const num = Number(normalizirano);
    return Number.isFinite(num) ? num : 0;
}

const MS_NA_DAN = 24 * 60 * 60 * 1000;

const MESECI_SL = [
    "januar",
    "februar",
    "marec",
    "april",
    "maj",
    "junij",
    "julij",
    "avgust",
    "september",
    "oktober",
    "november",
    "december",
];

const DNEVI_SL = ["Po", "To", "Sr", "Če", "Pe", "So", "Ne"];

function vISO(datum) {
    return (
        datum.getFullYear() +
        "-" +
        String(datum.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(datum.getDate()).padStart(2, "0")
    );
}

function formatirajDatumClovesko(iso) {
    if (!iso) return "";
    const [y, m, d] = String(iso).split("-");
    if (!y || !m || !d) return iso;
    return `${String(d).padStart(2, "0")}. ${String(m).padStart(2, "0")}. ${y}`;
}

const normalizirajStevilke = (v) =>
    String(v || "").replace(/\D/g, "").slice(0, 10);

function DatumIzbirnikSL({ name, value, onChange, className }) {
    const [odprto, nastaviOdprto] = useState(false);

    const [pogled, nastaviPogled] = useState(() => {
        const base = value ? new Date(value) : new Date();
        return new Date(base.getFullYear(), base.getMonth(), 1);
    });

    const skatlaRef = useRef(null);
    const vnosRef = useRef(null);
    const pravkarZaprtRef = useRef(false);

    const jeKompakten =
        className && className.split(/\s+/).includes("pobotnica-inputTiny");

    const zapriKoledar = () => {
        nastaviOdprto(false);
        pravkarZaprtRef.current = true;

        setTimeout(() => {
            pravkarZaprtRef.current = false;
        }, 250);
    };

    useEffect(() => {
        function obravnavaDogodka(e) {
            if (!skatlaRef.current) return;

            if (e.type === "keydown" && e.key === "Escape") {
                zapriKoledar();
                return;
            }

            if (e.type === "mousedown" && !skatlaRef.current.contains(e.target)) {
                zapriKoledar();
            }
        }

        if (odprto) {
            document.addEventListener("mousedown", obravnavaDogodka);
            document.addEventListener("keydown", obravnavaDogodka);

            return () => {
                document.removeEventListener("mousedown", obravnavaDogodka);
                document.removeEventListener("keydown", obravnavaDogodka);
            };
        }

        return undefined;
    }, [odprto]);

    const mreza = useMemo(() => {
        const prvi = new Date(pogled.getFullYear(), pogled.getMonth(), 1);
        const zadnji = new Date(pogled.getFullYear(), pogled.getMonth() + 1, 0);
        const prviDanVTednu = (prvi.getDay() + 6) % 7;
        const dniVMesecu = zadnji.getDate();
        const celice = [];

        const prejsnji = new Date(pogled.getFullYear(), pogled.getMonth(), 0);

        for (let i = prviDanVTednu - 1; i >= 0; i--) {
            const d = new Date(
                prejsnji.getFullYear(),
                prejsnji.getMonth(),
                prejsnji.getDate() - i
            );
            celice.push({ d, vMesecu: false });
        }

        for (let i = 1; i <= dniVMesecu; i++) {
            const d = new Date(pogled.getFullYear(), pogled.getMonth(), i);
            celice.push({ d, vMesecu: true });
        }

        while (celice.length < 42) {
            const zadnjaCelica = celice[celice.length - 1].d;
            const d = new Date(
                zadnjaCelica.getFullYear(),
                zadnjaCelica.getMonth(),
                zadnjaCelica.getDate() + 1
            );
            celice.push({ d, vMesecu: false });
        }

        return celice;
    }, [pogled]);

    const izbranKljuc = value ? String(value).slice(0, 10) : "";
    const danesKljuc = vISO(new Date());

    const izberiDatum = (iso) => {
        if (onChange) {
            onChange({ target: { name, value: iso } });
        }

        zapriKoledar();
        requestAnimationFrame(() => vnosRef.current?.blur());
    };

    return (
        <div
            ref={skatlaRef}
            style={{
                position: "relative",
                display: "inline-block",
                width: jeKompakten ? "auto" : "100%",
            }}
        >
            <input
                ref={vnosRef}
                type="text"
                name={name}
                className={className}
                value={formatirajDatumClovesko(value)}
                onFocus={() => {
                    if (!pravkarZaprtRef.current) nastaviOdprto(true);
                }}
                onClick={() => {
                    if (!pravkarZaprtRef.current) nastaviOdprto(true);
                }}
                readOnly
                placeholder="dd. mm. yyyy"
            />

            {odprto && (
                <div
                    style={{
                        position: "absolute",
                        zIndex: 40,
                        top: "110%",
                        left: 0,
                        background: "#ffffff",
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        boxShadow: "0 10px 24px rgba(15,23,42,.18)",
                        padding: 8,
                        minWidth: 230,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 6,
                            fontSize: "0.8rem",
                            fontWeight: 600,
                            gap: 4,
                        }}
                    >
                        <div style={{ display: "flex", gap: 2 }}>
                            <button
                                type="button"
                                onClick={() =>
                                    nastaviPogled(
                                        (v) =>
                                            new Date(
                                                v.getFullYear() - 1,
                                                v.getMonth(),
                                                1
                                            )
                                    )
                                }
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    padding: 2,
                                }}
                                aria-label="Prejšnje leto"
                            >
                                «
                            </button>

                            <button
                                type="button"
                                onClick={() =>
                                    nastaviPogled(
                                        (v) =>
                                            new Date(
                                                v.getFullYear(),
                                                v.getMonth() - 1,
                                                1
                                            )
                                    )
                                }
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    padding: 2,
                                }}
                                aria-label="Prejšnji mesec"
                            >
                                ‹
                            </button>
                        </div>

                        <div>
                            {MESECI_SL[pogled.getMonth()]} {pogled.getFullYear()}
                        </div>

                        <div style={{ display: "flex", gap: 2 }}>
                            <button
                                type="button"
                                onClick={() =>
                                    nastaviPogled(
                                        (v) =>
                                            new Date(
                                                v.getFullYear(),
                                                v.getMonth() + 1,
                                                1
                                            )
                                    )
                                }
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    padding: 2,
                                }}
                                aria-label="Naslednji mesec"
                            >
                                ›
                            </button>

                            <button
                                type="button"
                                onClick={() =>
                                    nastaviPogled(
                                        (v) =>
                                            new Date(
                                                v.getFullYear() + 1,
                                                v.getMonth(),
                                                1
                                            )
                                    )
                                }
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    padding: 2,
                                }}
                                aria-label="Naslednje leto"
                            >
                                »
                            </button>
                        </div>
                    </div>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(7, 1fr)",
                            gap: 2,
                            fontSize: "0.75rem",
                            textAlign: "center",
                            marginBottom: 4,
                        }}
                    >
                        {DNEVI_SL.map((d) => (
                            <div key={d} style={{ fontWeight: 600 }}>
                                {d}
                            </div>
                        ))}

                        {mreza.map(({ d, vMesecu }, idx) => {
                            const iso = vISO(d);
                            const jeIzbran = izbranKljuc && iso === izbranKljuc;
                            const jeDanes = iso === danesKljuc;

                            return (
                                <button
                                    key={iso + "-" + idx}
                                    type="button"
                                    onClick={() => izberiDatum(iso)}
                                    style={{
                                        border: "none",
                                        borderRadius: 4,
                                        padding: "4px 0",
                                        cursor: "pointer",
                                        fontSize: "0.8rem",
                                        backgroundColor: jeIzbran
                                            ? "#2563eb"
                                            : jeDanes
                                                ? "#e0f2fe"
                                                : "transparent",
                                        color: !vMesecu
                                            ? "#9ca3af"
                                            : jeIzbran
                                                ? "#ffffff"
                                                : "#111827",
                                    }}
                                >
                                    {d.getDate()}
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}

function prvaVrednost(...values) {
    for (const value of values) {
        const text = String(value ?? "").trim();
        if (text) return text;
    }

    return "";
}

function normalizirajPrijavljenegaIzvrsitelja(data) {
    const email = prvaVrednost(
        data?.email,
        data?.Email,
        data?.ePosta,
        data?.EPosta
    );

    const ime = prvaVrednost(
        data?.firstName,
        data?.FirstName,
        data?.ime,
        data?.Ime
    );

    const priimek = prvaVrednost(
        data?.lastName,
        data?.LastName,
        data?.priimek,
        data?.Priimek
    );

    const fullName = prvaVrednost(
        data?.fullName,
        data?.FullName,
        [ime, priimek].filter(Boolean).join(" "),
        email
    );

    return {
        izvrsitelj: fullName,
        naslovIzvrsitelja: prvaVrednost(
            data?.address,
            data?.Address,
            data?.naslov,
            data?.Naslov
        ),
        gsmIzvrsitelja: prvaVrednost(
            data?.gsm,
            data?.Gsm,
            data?.mobile,
            data?.Mobile
        ),
        ePostaIzvrsitelja: email,
    };
}

const Pobotnica = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const [podatkiPrijavljenegaIzvrsitelja, nastaviPodatkePrijavljenegaIzvrsitelja] = useState(null);

    const pobotnicaContainerRef = useRef(null);

    const inicialnaDavcnaAliMaticna = normalizirajStevilke(
        location.state?.davcnaAliMaticna ?? ""
    );

    const [obrazec, nastaviObrazec] = useState(() => {
        const danesIso = vISO(new Date());

        return {
            ...zacetnoStanje,
            datumPobotnice: danesIso,
        };
    });

    const [opombaObresti, nastaviOpomboObresti] = useState("");

    const [davcnaAliMaticnaUpnika, nastaviDavcnoAliMaticnoUpnika] =
        useState(inicialnaDavcnaAliMaticna);

    const [napakaUpnik, nastaviNapakoUpnik] = useState("");
    const [nalaganjeUpnik, nastaviNalaganjeUpnik] = useState(false);

    const [pobotnicaShranjevanje, nastaviPobotnicaShranjevanje] =
        useState(false);
    const [pobotnicaSporocilo, nastaviPobotnicaSporocilo] = useState("");
    const [pobotnicaId, nastaviPobotnicaId] = useState(null);
    const [izvornaStevilkaSpisa, nastaviIzvornaStevilkaSpisa] = useState("");

    const [pdfShranjevanje, nastaviPdfShranjevanje] = useState(false);

    const [kreirajHighlight, nastaviKreirajHighlight] = useState(true);

    useEffect(() => {
        if (!kreirajHighlight) return undefined;

        const timeoutId = setTimeout(() => {
            nastaviKreirajHighlight(false);
        }, 1200);

        return () => clearTimeout(timeoutId);
    }, [kreirajHighlight]);

    const napolniUpnikaIzObjekta = (vir) => {
        if (!vir) return;

        const naziv =
            vir.naziv ??
            vir.Naziv ??
            vir.name ??
            vir.Name ??
            vir.upnikNaziv ??
            vir.UpnikNaziv ??
            vir.ajpesNaziv ??
            vir.AjpesNaziv ??
            "";

        const naslov = [
            vir.naslov ??
            vir.Naslov ??
            vir.address ??
            vir.Address ??
            vir.ajpesNaslov ??
            vir.AjpesNaslov ??
            "",
            vir.posta ??
            vir.Posta ??
            vir.post ??
            vir.Post ??
            vir.ajpesPosta ??
            vir.AjpesPosta ??
            "",
            vir.drzava ??
            vir.Drzava ??
            vir.country ??
            vir.Country ??
            vir.ajpesDrzava ??
            vir.AjpesDrzava ??
            "",
        ]
            .filter(Boolean)
            .join(", ");

        if (!naziv && !naslov) return;

        nastaviObrazec((prej) => {
            const naslednji = { ...prej };

            if (naziv) naslednji.nazivUpnika = naziv;
            if (naslov) naslednji.naslovUpnika = naslov;

            return naslednji;
        });
    };

    const napolniObrazecIzPobotnice = (dto) => {
        if (!dto) return;

        const data = dto.obrazec || dto.Obrazec || {};

        const normalizirajDatum = (d) => (!d ? "" : String(d).slice(0, 10));

        const formatirajZnesek = (v) => {
            if (v == null || v === "") return "";

            const n = Number(
                typeof v === "string"
                    ? v.replace(/\s/g, "").replace(",", ".")
                    : v
            );

            if (!Number.isFinite(n)) return String(v);

            return n.toLocaleString("sl-SI", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        };

        nastaviObrazec((prej) => {
            const naslednji = {
                ...prej,
                ...data,
                datumPobotnice: normalizirajDatum(
                    data.datumPobotnice ?? data.DatumPobotnice ?? prej.datumPobotnice
                ),
                datumPrejema: normalizirajDatum(
                    data.datumPrejema ?? data.DatumPrejema ?? prej.datumPrejema
                ),
                obrestiOd: normalizirajDatum(
                    data.obrestiOd ?? data.ObrestiOd ?? prej.obrestiOd
                ),
                obrestiDo: normalizirajDatum(
                    data.obrestiDo ?? data.ObrestiDo ?? prej.obrestiDo
                ),
                datumPodpisaStranke: normalizirajDatum(
                    data.datumPodpisaStranke ??
                    data.DatumPodpisaStranke ??
                    prej.datumPodpisaStranke
                ),
                datumPodpisaIzvrsitelja: normalizirajDatum(
                    data.datumPodpisaIzvrsitelja ??
                    data.DatumPodpisaIzvrsitelja ??
                    prej.datumPodpisaIzvrsitelja
                ),
                glavnica: formatirajZnesek(
                    data.glavnica ?? data.Glavnica ?? prej.glavnica
                ),
                znesekObresti: formatirajZnesek(
                    data.znesekObresti ?? data.ZnesekObresti ?? prej.znesekObresti
                ),
                pravdniStroski: formatirajZnesek(
                    data.pravdniStroski ?? data.PravdniStroski ?? prej.pravdniStroski
                ),
                izvrsilniStroski: formatirajZnesek(
                    data.izvrsilniStroski ??
                    data.IzvrsilniStroski ??
                    prej.izvrsilniStroski
                ),
                takse: formatirajZnesek(data.takse ?? data.Takse ?? prej.takse),
                drugaPostavkaEZnesek: formatirajZnesek(
                    data.drugaPostavkaEZnesek ??
                    data.DrugaPostavkaEZnesek ??
                    prej.drugaPostavkaEZnesek
                ),
                drugaPostavkaFZnesek: formatirajZnesek(
                    data.drugaPostavkaFZnesek ??
                    data.DrugaPostavkaFZnesek ??
                    prej.drugaPostavkaFZnesek
                ),
            };

            delete naslednji.telefonIzvrsitelja;
            delete naslednji.TelefonIzvrsitelja;

            for (const kljuc of Object.keys(zacetnoStanje)) {
                if (naslednji[kljuc] == null) {
                    naslednji[kljuc] = zacetnoStanje[kljuc] ?? "";
                }
            }

            const prijavljeni = podatkiPrijavljenegaIzvrsitelja;

            if (prijavljeni) {
                const nastaviCePrazno = (field, value) => {
                    const trenutno = String(naslednji[field] ?? "").trim();
                    const novo = String(value ?? "").trim();

                    if (!trenutno && novo) {
                        naslednji[field] = novo;
                    }
                };

                nastaviCePrazno("izvrsitelj", prijavljeni.izvrsitelj);
                nastaviCePrazno("naslovIzvrsitelja", prijavljeni.naslovIzvrsitelja);
                nastaviCePrazno("gsmIzvrsitelja", prijavljeni.gsmIzvrsitelja);
                nastaviCePrazno("ePostaIzvrsitelja", prijavljeni.ePostaIzvrsitelja);
            }

            return naslednji;
        });

        if (dto.id || dto.Id) {
            nastaviPobotnicaId(dto.id ?? dto.Id);
        }

        const spisIzDto =
            data.stevilkaSpisaIzvrsitelja ??
            data.StevilkaSpisaIzvrsitelja ??
            dto.stevilkaSpisaIzvrsitelja ??
            dto.StevilkaSpisaIzvrsitelja ??
            "";

        nastaviIzvornaStevilkaSpisa(spisIzDto || "");

        if (dto.davcnaAliMaticnaUpnika || dto.davcnaAliMaticna) {
            const stevke = normalizirajStevilke(
                dto.davcnaAliMaticnaUpnika ?? dto.davcnaAliMaticna ?? ""
            );

            nastaviDavcnoAliMaticnoUpnika(stevke);
        }
    };

    const pridobiUpnika = async () => {
        nastaviNapakoUpnik("");

        const stevke = normalizirajStevilke(davcnaAliMaticnaUpnika);

        if (!stevke) {
            nastaviNapakoUpnik("Vpiši davčno ali matično številko upnika.");
            return;
        }

        if (!(stevke.length === 8 || stevke.length === 10)) {
            nastaviNapakoUpnik("Vpiši davčno (8) ali matično (10) številk.");
            return;
        }

        nastaviNalaganjeUpnik(true);

        try {
            const resAjpes = await apiFetch(`/api/ajpes/prs/${stevke}`, {
                method: "GET",
            });

            if (!resAjpes.ok) {
                let msg = "";

                try {
                    const json = await resAjpes.json();
                    msg = json?.message || json?.title || "";
                } catch {
                    msg = await resAjpes.text().catch(() => "");
                }

                throw new Error(msg || "AJPES poizvedba ni uspela.");
            }

            let dataAjpes;

            try {
                dataAjpes = await resAjpes.json();
            } catch {
                throw new Error("Neveljaven odgovor strežnika (AJPES).");
            }

            napolniUpnikaIzObjekta(dataAjpes);
        } catch (e) {
            nastaviNapakoUpnik(
                e?.message || "Napaka pri pridobivanju podatkov iz AJPES."
            );
        } finally {
            nastaviNalaganjeUpnik(false);
        }
    };

    useEffect(() => {
        if (!id && davcnaAliMaticnaUpnika) {
            void pridobiUpnika();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, davcnaAliMaticnaUpnika]);

    const naloziPobotnicoIzBaze = async (idZaNaloziti) => {
        if (!idZaNaloziti) return;

        nastaviPobotnicaSporocilo("");
        nastaviPobotnicaShranjevanje(false);

        try {
            const res = await apiFetch(`/api/stran/pobotnica/${idZaNaloziti}`, {
                method: "GET",
            });

            if (res.status === 404) {
                nastaviPobotnicaSporocilo(
                    "Pobotnice ni mogoče najti (morda je bila izbrisana)."
                );
                return;
            }

            if (!res.ok) {
                let msg = "";

                try {
                    const json = await res.json();
                    msg = json?.message || json?.title || "";
                } catch {
                    msg = await res.text().catch(() => "");
                }

                throw new Error(msg || "Napaka pri branju pobotnice iz baze.");
            }

            const data = await res.json();
            napolniObrazecIzPobotnice(data);
        } catch (e) {
            nastaviPobotnicaSporocilo(
                e?.message || "Napaka pri branju pobotnice iz baze."
            );
        }
    };

    useEffect(() => {
        if (!id) return;
        naloziPobotnicoIzBaze(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const shraniPobotnico = async () => {
        nastaviPobotnicaSporocilo("");
        nastaviPobotnicaShranjevanje(true);

        try {
            const stevke = normalizirajStevilke(davcnaAliMaticnaUpnika);

            if (!stevke || !(stevke.length === 8 || stevke.length === 10)) {
                nastaviPobotnicaSporocilo(
                    "Za shranjevanje pobotnice je potrebna davčna (8) ali matična (10) številka upnika."
                );
                return;
            }

            const spisTrenutni = (obrazec.stevilkaSpisaIzvrsitelja || "").trim();
            const oprTrenutni = (obrazec.opravilnaStevilkaSodisca || "").trim();

            if (!spisTrenutni && !oprTrenutni) {
                nastaviPobotnicaSporocilo(
                    "Vnesite št. spisa izvršitelja ali opr. št. sodišča."
                );
                return;
            }

            let idZaPoslati = pobotnicaId;
            const spisIzvorni = (izvornaStevilkaSpisa || "").trim();

            if (
                idZaPoslati &&
                spisTrenutni &&
                spisIzvorni &&
                spisTrenutni !== spisIzvorni
            ) {
                idZaPoslati = null;
            }

            const {
                telefonIzvrsitelja,
                TelefonIzvrsitelja,
                ...obrazecBrezTelefona
            } = obrazec;

            const payload = {
                id: idZaPoslati,
                davcnaAliMaticna: stevke,
                obrazec: {
                    ...obrazecBrezTelefona,
                    stevilkaSpisaIzvrsitelja: spisTrenutni,
                    opravilnaStevilkaSodisca: oprTrenutni,
                },
            };

            const res = await apiFetch("/api/stran/pobotnica", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (!res.ok) {
                let msg = "Napaka pri shranjevanju pobotnice.";

                try {
                    const data = await res.json();
                    if (data?.message) msg = data.message;
                    if (data?.title) msg = data.title;
                } catch {
                    const text = await res.text().catch(() => "");
                    if (text) msg = text;
                }

                nastaviPobotnicaSporocilo(msg);
                return;
            }

            let odgovor = null;

            try {
                odgovor = await res.json();
            } catch {
                // ignoriraj
            }

            const msg = odgovor?.message || "Pobotnica je bila uspešno shranjena.";
            const novId = odgovor?.id ?? idZaPoslati ?? pobotnicaId ?? null;

            nastaviPobotnicaSporocilo(msg);

            if (novId) {
                nastaviPobotnicaId(novId);
                nastaviIzvornaStevilkaSpisa(spisTrenutni);
            }

            nastaviOpomboObresti("");
        } catch (e) {
            nastaviPobotnicaSporocilo(
                e?.message || "Napaka pri shranjevanju pobotnice."
            );
        } finally {
            nastaviPobotnicaShranjevanje(false);
        }
    };

    const skupajZnesek =
        pretvoriZnesek(obrazec.glavnica) +
        pretvoriZnesek(obrazec.znesekObresti) +
        pretvoriZnesek(obrazec.pravdniStroski) +
        pretvoriZnesek(obrazec.izvrsilniStroski) +
        pretvoriZnesek(obrazec.takse) +
        pretvoriZnesek(obrazec.drugaPostavkaEZnesek) +
        pretvoriZnesek(obrazec.drugaPostavkaFZnesek);

    const obravnavaSpremembe = (e) => {
        const { name, value } = e.target;
        nastaviObrazec((prej) => ({ ...prej, [name]: value }));
    };

    const obravnavaSpremembeObrestneMere = (e) => {
        const raw = e.target.value || "";
        const ocisceno = raw.replace(/[^0-9.,]/g, "");
        nastaviObrazec((prej) => ({ ...prej, obrestnaMera: ocisceno }));
    };

    const natisni = async () => {
        const element = pobotnicaContainerRef.current;

        if (!element) {
            window.print();
            return;
        }

        try {
            element.classList.add("pobotnica-pdfMode");

            await new Promise((resolve) => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(resolve);
                });
            });

            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                backgroundColor: "#ffffff",
                logging: false,
            });

            const imgData = canvas.toDataURL("image/png");

            const iframe = document.createElement("iframe");
            iframe.style.position = "fixed";
            iframe.style.right = "0";
            iframe.style.bottom = "0";
            iframe.style.width = "0";
            iframe.style.height = "0";
            iframe.style.border = "0";
            iframe.style.visibility = "hidden";

            document.body.appendChild(iframe);

            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

            iframeDoc.open();
            iframeDoc.write(`
                <!doctype html>
                <html>
                    <head>
                        <title>Pobotnica</title>
                        <style>
                            @page {
                                size: A4 portrait;
                                margin: 8mm;
                            }

                            html,
                            body {
                                margin: 0;
                                padding: 0;
                                background: #ffffff;
                            }

                            body {
                                width: 100%;
                                min-height: 100vh;
                                display: flex;
                                align-items: flex-start;
                                justify-content: center;
                            }

                            img {
                                display: block;
                                width: 100%;
                                max-width: 194mm;
                                height: auto;
                                object-fit: contain;
                            }

                            @media print {
                                html,
                                body {
                                    width: 100%;
                                    height: auto;
                                    background: #ffffff;
                                }

                                img {
                                    width: 100%;
                                    max-width: 194mm;
                                    max-height: 281mm;
                                    object-fit: contain;
                                }
                            }
                        </style>
                    </head>
                    <body>
                        <img src="${imgData}" alt="Pobotnica" />
                    </body>
                </html>
            `);
            iframeDoc.close();

            iframe.onload = () => {
                const iframeWindow = iframe.contentWindow;

                setTimeout(() => {
                    iframeWindow.focus();
                    iframeWindow.print();

                    setTimeout(() => {
                        document.body.removeChild(iframe);
                    }, 1000);
                }, 300);
            };
        } catch (e) {
            nastaviPobotnicaSporocilo(
                e?.message || "Napaka pri pripravi tiskanja pobotnice."
            );
        } finally {
            element.classList.remove("pobotnica-pdfMode");
        }
    };

    const shraniPdf = async () => {
        if (pdfShranjevanje) return;

        const element = pobotnicaContainerRef.current;

        if (!element) {
            nastaviPobotnicaSporocilo("PDF ni mogoče ustvariti.");
            return;
        }

        nastaviPdfShranjevanje(true);
        nastaviPobotnicaSporocilo("");

        try {
            element.classList.add("pobotnica-pdfMode");

            await new Promise((resolve) => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(resolve);
                });
            });

            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                backgroundColor: "#ffffff",
                logging: false,
            });

            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF("p", "mm", "a4");
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            const margin = 10;
            const usableWidth = pageWidth - margin * 2;
            const usableHeight = pageHeight - margin * 2;

            const imgWidth = usableWidth;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            let y = margin;
            let remainingHeight = imgHeight;

            pdf.addImage(imgData, "PNG", margin, y, imgWidth, imgHeight);
            remainingHeight -= usableHeight;

            while (remainingHeight > 0) {
                y -= usableHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", margin, y, imgWidth, imgHeight);
                remainingHeight -= usableHeight;
            }

            const spis = (obrazec.stevilkaSpisaIzvrsitelja || "").trim();
            const opravilna = (obrazec.opravilnaStevilkaSodisca || "").trim();
            const datum = obrazec.datumPobotnice || vISO(new Date());

            const osnovnoIme = [spis, opravilna, datum]
                .filter(Boolean)
                .join("_")
                .replace(/[^a-zA-Z0-9_-]+/g, "_")
                .slice(0, 120);

            pdf.save(`${osnovnoIme || "pobotnica"}.pdf`);

            nastaviPobotnicaSporocilo("PDF je bil uspešno ustvarjen.");
        } catch (e) {
            nastaviPobotnicaSporocilo(
                e?.message || "Napaka pri ustvarjanju PDF dokumenta."
            );
        } finally {
            element.classList.remove("pobotnica-pdfMode");
            nastaviPdfShranjevanje(false);
        }
    };

    const izracunajObresti = () => {
        const glavnicniRaw = String(obrazec.glavnica || "").trim();
        const meraRaw = String(obrazec.obrestnaMera || "").trim();

        if (!/\d/.test(glavnicniRaw)) {
            nastaviOpomboObresti(
                "V polje 'a) Glavnica' vnesi znesek glavnice v EUR (samo številke)."
            );
            return;
        }

        if (!/\d/.test(meraRaw)) {
            nastaviOpomboObresti(
                "V polje 'b) obresti po %' vnesi obrestno mero (samo številke)."
            );
            return;
        }

        const P = pretvoriZnesek(glavnicniRaw);
        const mera = Number(meraRaw.replace(",", "."));
        const od = obrazec.obrestiOd ? new Date(obrazec.obrestiOd) : null;
        const doDat = obrazec.obrestiDo ? new Date(obrazec.obrestiDo) : null;

        const odMs = od ? od.getTime() : NaN;
        const doMs = doDat ? doDat.getTime() : NaN;

        if (!Number.isFinite(P) || P <= 0) {
            nastaviOpomboObresti("Glavnica mora biti pozitiven znesek v EUR.");
            return;
        }

        if (!Number.isFinite(mera) || mera <= 0) {
            nastaviOpomboObresti(
                "Obrestna mera mora biti pozitivno število (npr. 8 ali 8,5)."
            );
            return;
        }

        if (!Number.isFinite(odMs) || !Number.isFinite(doMs)) {
            nastaviOpomboObresti("Izberi oba datuma za obdobje obrestovanja.");
            return;
        }

        const diffMs = doMs - odMs;

        if (diffMs <= 0) {
            nastaviOpomboObresti("Končni datum mora biti po začetnem.");
            return;
        }

        const dni = Math.round(diffMs / MS_NA_DAN);
        const obresti = (P * (mera / 100) * dni) / 365;

        const formatirano = obresti.toLocaleString("sl-SI", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        nastaviObrazec((prej) => ({ ...prej, znesekObresti: formatirano }));
        nastaviOpomboObresti(`Izračunano za ${dni} dni.`);
    };

    useEffect(() => {
        let ziv = true;

        (async () => {
            try {
                const res = await apiFetch("/api/auth/me");

                if (!res.ok) return;

                const data = await res.json();

                if (!ziv) return;

                nastaviPodatkePrijavljenegaIzvrsitelja(
                    normalizirajPrijavljenegaIzvrsitelja(data)
                );
            } catch {
                // ignoriraj
            }
        })();

        return () => {
            ziv = false;
        };
    }, []);

    useEffect(() => {
        if (!podatkiPrijavljenegaIzvrsitelja) return;

        nastaviObrazec((prej) => {
            const naslednji = { ...prej };
            let spremenjeno = false;

            const nastaviCePrazno = (field, value) => {
                const trenutno = String(naslednji[field] ?? "").trim();
                const novo = String(value ?? "").trim();

                if (!trenutno && novo) {
                    naslednji[field] = novo;
                    spremenjeno = true;
                }
            };

            nastaviCePrazno(
                "izvrsitelj",
                podatkiPrijavljenegaIzvrsitelja.izvrsitelj
            );

            nastaviCePrazno(
                "naslovIzvrsitelja",
                podatkiPrijavljenegaIzvrsitelja.naslovIzvrsitelja
            );

            nastaviCePrazno(
                "gsmIzvrsitelja",
                podatkiPrijavljenegaIzvrsitelja.gsmIzvrsitelja
            );

            nastaviCePrazno(
                "ePostaIzvrsitelja",
                podatkiPrijavljenegaIzvrsitelja.ePostaIzvrsitelja
            );

            if ("telefonIzvrsitelja" in naslednji) {
                delete naslednji.telefonIzvrsitelja;
                spremenjeno = true;
            }

            if ("TelefonIzvrsitelja" in naslednji) {
                delete naslednji.TelefonIzvrsitelja;
                spremenjeno = true;
            }

            return spremenjeno ? naslednji : prej;
        });
    }, [podatkiPrijavljenegaIzvrsitelja]);

    return (
        <div className="pf">
            <main className="pobotnica-page">
                <section className="pobotnica-modePicker pobotnica-noPrint">
                    <button
                        type="button"
                        className="pobotnica-modeBtn"
                        onClick={() => navigate("/profil/pobotnica/iskanje")}
                        aria-pressed="false"
                    >
                        <FiSearch className="pobotnica-modeBtnIcon" aria-hidden="true" />
                        <span>IŠČI POBOTNICO V BAZI</span>
                    </button>

                    <button
                        type="button"
                        className={
                            "pobotnica-modeBtn pobotnica-modeBtn--active" +
                            (kreirajHighlight ? " pobotnica-modeBtn--highlight" : "")
                        }
                        aria-pressed="true"
                    >
                        <FiFilePlus className="pobotnica-modeBtnIcon" aria-hidden="true" />
                        <span>KREIRAJ POBOTNICO</span>
                    </button>

                    <button
                        type="button"
                        className="pobotnica-modeBtn"
                        onClick={() => navigate("/profil", { replace: true })}
                    >
                        <FiArrowLeft className="pobotnica-modeBtnIcon" aria-hidden="true" />
                        <span>NAZAJ</span>
                    </button>
                </section>

                <div className="pobotnica-container" ref={pobotnicaContainerRef}>
                    <header className="pobotnica-head">
                        <div className="pobotnica-headLeft">
                            <img
                                src="/grb.png"
                                alt="Grb Republike Slovenije"
                                className="pobotnica-headLeftLogo"
                            />

                            <div className="pobotnica-headLeftText">
                                <div className="pobotnica-country">
                                    REPUBLIKA SLOVENIJA
                                </div>

                                <div className="pobotnica-contactList">
                                    <label className="pobotnica-contactField pobotnica-contactField--izvrsitelj">
                                        <span>Izvršitelj</span>
                                        <input
                                            type="text"
                                            name="izvrsitelj"
                                            value={obrazec.izvrsitelj}
                                            onChange={obravnavaSpremembe}
                                            className="pobotnica-contactInput pobotnica-contactInput--izvrsitelj"
                                            placeholder="Vpiši izvršitelja"
                                        />
                                    </label>
                                </div>

                                <div className="pobotnica-contactList">
                                    <label className="pobotnica-contactField">
                                        <span>Naslov</span>
                                        <input
                                            type="text"
                                            name="naslovIzvrsitelja"
                                            value={obrazec.naslovIzvrsitelja}
                                            onChange={obravnavaSpremembe}
                                            className="pobotnica-contactInput"
                                        />
                                    </label>

                                    <label className="pobotnica-contactField">
                                        <span>GSM</span>
                                        <input
                                            type="text"
                                            name="gsmIzvrsitelja"
                                            value={obrazec.gsmIzvrsitelja}
                                            onChange={obravnavaSpremembe}
                                            className="pobotnica-contactInput"
                                        />
                                    </label>

                                    <label className="pobotnica-contactField">
                                        <span>E-pošta</span>
                                        <input
                                            type="email"
                                            name="ePostaIzvrsitelja"
                                            value={obrazec.ePostaIzvrsitelja}
                                            onChange={obravnavaSpremembe}
                                            className="pobotnica-contactInput"
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="pobotnica-headRight">
                            <div className="pobotnica-refRow">
                                <label className="pobotnica-refField">
                                    <span className="pobotnica-refFieldLabel">
                                        Št. spisa izvršitelja
                                    </span>
                                    <input
                                        type="text"
                                        name="stevilkaSpisaIzvrsitelja"
                                        value={obrazec.stevilkaSpisaIzvrsitelja}
                                        onChange={obravnavaSpremembe}
                                        className="pobotnica-refFieldInput"
                                    />
                                </label>

                                <label className="pobotnica-refField">
                                    <span className="pobotnica-refFieldLabel">
                                        Opr. št. sodišča
                                    </span>
                                    <input
                                        type="text"
                                        name="opravilnaStevilkaSodisca"
                                        value={obrazec.opravilnaStevilkaSodisca}
                                        onChange={obravnavaSpremembe}
                                        className="pobotnica-refFieldInput"
                                    />
                                </label>
                            </div>

                            <label className="pobotnica-refFieldFull">
                                <span className="pobotnica-refFieldLabel">
                                    Datum
                                </span>
                                <DatumIzbirnikSL
                                    name="datumPobotnice"
                                    value={obrazec.datumPobotnice}
                                    onChange={obravnavaSpremembe}
                                    className="pobotnica-refFieldInput"
                                />
                            </label>
                        </div>
                    </header>

                    <h2 className="pobotnica-title">POBOTNICA</h2>

                    <section className="pobotnica-body">
                        <section className="pobotnica-ajpesPanel pobotnica-noPrint">
                            <div className="pobotnica-ajpesPanelHeader">
                                <div className="pobotnica-ajpesPanelTitle">
                                    Iskanje podatkov o upniku v AJPES
                                </div>
                            </div>

                            <div className="pobotnica-rowIntro pobotnica-rowIntro--ajpes">
                                <span className="pobotnica-rowIntroLabel">
                                    Davčna ali matična št. upnika: (24995975)
                                </span>

                                <input
                                    type="text"
                                    value={davcnaAliMaticnaUpnika}
                                    onChange={(e) => {
                                        nastaviNapakoUpnik("");
                                        const v = normalizirajStevilke(e.target.value);
                                        nastaviDavcnoAliMaticnoUpnika(v);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            pridobiUpnika();
                                        }
                                    }}
                                    className="pobotnica-input pobotnica-rowIntroPayer"
                                    inputMode="numeric"
                                    placeholder="npr. 12345678 ali 1234567000"
                                />

                                <button
                                    type="button"
                                    className="pobotnica-inlineBtn"
                                    onClick={pridobiUpnika}
                                    disabled={nalaganjeUpnik}
                                >
                                    {nalaganjeUpnik
                                        ? "Iskanje…"
                                        : "Pridobi podatke iz AJPES"}
                                </button>
                            </div>

                            {napakaUpnik && (
                                <div className="pobotnica-ajpesError">
                                    {napakaUpnik}
                                </div>
                            )}
                        </section>

                        <div className="pobotnica-rowIntro pobotnica-rowIntro--prejem">
                            <span className="pobotnica-rowIntroLabel">
                                Potrjujem, da sem prejel dne:
                            </span>

                            <DatumIzbirnikSL
                                name="datumPrejema"
                                value={obrazec.datumPrejema}
                                onChange={obravnavaSpremembe}
                                className="pobotnica-dateInput"
                            />

                            <span className="pobotnica-rowIntroLabel pobotnica-rowIntroLabel--od">
                                od (plačnik):
                            </span>

                            <input
                                type="text"
                                name="placnik"
                                value={obrazec.placnik}
                                onChange={obravnavaSpremembe}
                                className="pobotnica-input pobotnica-rowIntroPayer"
                                placeholder="ime, priimek / firma in naslov plačnika"
                            />
                        </div>

                        <div className="pobotnica-rowIntro pobotnica-rowIntro--upnik">
                            <span className="pobotnica-rowIntroLabel">
                                Upnik – ime / firma:
                            </span>

                            <input
                                type="text"
                                name="nazivUpnika"
                                value={obrazec.nazivUpnika}
                                onChange={obravnavaSpremembe}
                                className="pobotnica-input"
                                placeholder="ime in priimek ali firma upnika"
                            />

                            <span className="pobotnica-rowIntroLabel">
                                Upnik – naslov:
                            </span>

                            <input
                                type="text"
                                name="naslovUpnika"
                                value={obrazec.naslovUpnika}
                                onChange={obravnavaSpremembe}
                                className="pobotnica-input"
                                placeholder="ulica, hišna št., poštna št., kraj, država"
                            />
                        </div>

                        <label className="pobotnica-fieldBlock">
                            iz naslova
                            <textarea
                                name="opisPlacila"
                                value={obrazec.opisPlacila}
                                onChange={obravnavaSpremembe}
                                rows={2}
                                className="pobotnica-textarea"
                                placeholder="npr. prostovoljno plačilo dolga po sklepu o izvršbi ..."
                            />
                        </label>

                        <div className="pobotnica-table">
                            <div className="pobotnica-tableHeader">
                                <span>Postavka</span>
                                <span className="pobotnica-alignRight">
                                    Znesek (EUR)
                                </span>
                            </div>

                            <div className="pobotnica-tableRow">
                                <div className="pobotnica-tableText">
                                    a) Glavnica
                                </div>

                                <input
                                    type="text"
                                    name="glavnica"
                                    value={obrazec.glavnica}
                                    onChange={obravnavaSpremembe}
                                    className="pobotnica-amountInput"
                                />
                            </div>

                            <div className="pobotnica-tableRow pobotnica-tableRowMulti">
                                <div className="pobotnica-tableText">
                                    b) obresti po{" "}
                                    <input
                                        type="text"
                                        name="obrestnaMera"
                                        value={obrazec.obrestnaMera}
                                        onChange={obravnavaSpremembeObrestneMere}
                                        className="pobotnica-inputTiny"
                                        inputMode="decimal"
                                        pattern="[0-9]*[.,]?[0-9]*"
                                        placeholder="%"
                                    />{" "}
                                    % od dne{" "}
                                    <DatumIzbirnikSL
                                        name="obrestiOd"
                                        value={obrazec.obrestiOd}
                                        onChange={obravnavaSpremembe}
                                        className="pobotnica-inputTiny"
                                    />{" "}
                                    do dne{" "}
                                    <DatumIzbirnikSL
                                        name="obrestiDo"
                                        value={obrazec.obrestiDo}
                                        onChange={obravnavaSpremembe}
                                        className="pobotnica-inputTiny"
                                    />
                                    <button
                                        type="button"
                                        className="pobotnica-inlineBtn pobotnica-noPrint"
                                        onClick={izracunajObresti}
                                    >
                                        Izračunaj obresti
                                    </button>
                                </div>

                                <input
                                    type="text"
                                    name="znesekObresti"
                                    value={obrazec.znesekObresti}
                                    onChange={obravnavaSpremembe}
                                    className="pobotnica-amountInput"
                                />
                            </div>

                            {opombaObresti && (
                                <div className="pobotnica-smallText pobotnica-interestNote pobotnica-noPrint">
                                    {opombaObresti}
                                </div>
                            )}

                            <div className="pobotnica-tableRow">
                                <div className="pobotnica-tableText">
                                    c) pravdnih stroškov
                                </div>

                                <input
                                    type="text"
                                    name="pravdniStroski"
                                    value={obrazec.pravdniStroski}
                                    onChange={obravnavaSpremembe}
                                    className="pobotnica-amountInput"
                                />
                            </div>

                            <div className="pobotnica-tableRow">
                                <div className="pobotnica-tableText">
                                    č) izvršilnih stroškov
                                </div>

                                <input
                                    type="text"
                                    name="izvrsilniStroski"
                                    value={obrazec.izvrsilniStroski}
                                    onChange={obravnavaSpremembe}
                                    className="pobotnica-amountInput"
                                />
                            </div>

                            <div className="pobotnica-tableRow">
                                <div className="pobotnica-tableText">
                                    d) taks
                                </div>

                                <input
                                    type="text"
                                    name="takse"
                                    value={obrazec.takse}
                                    onChange={obravnavaSpremembe}
                                    className="pobotnica-amountInput"
                                />
                            </div>

                            <div className="pobotnica-tableRow">
                                <input
                                    type="text"
                                    name="drugaPostavkaETekst"
                                    value={obrazec.drugaPostavkaETekst}
                                    onChange={obravnavaSpremembe}
                                    className="pobotnica-tableTextInput"
                                    placeholder="e) druga postavka (opis)"
                                />

                                <input
                                    type="text"
                                    name="drugaPostavkaEZnesek"
                                    value={obrazec.drugaPostavkaEZnesek}
                                    onChange={obravnavaSpremembe}
                                    className="pobotnica-amountInput"
                                />
                            </div>

                            <div className="pobotnica-tableRow">
                                <input
                                    type="text"
                                    name="drugaPostavkaFTekst"
                                    value={obrazec.drugaPostavkaFTekst}
                                    onChange={obravnavaSpremembe}
                                    className="pobotnica-tableTextInput"
                                    placeholder="f) druga postavka (opis)"
                                />

                                <input
                                    type="text"
                                    name="drugaPostavkaFZnesek"
                                    value={obrazec.drugaPostavkaFZnesek}
                                    onChange={obravnavaSpremembe}
                                    className="pobotnica-amountInput"
                                />
                            </div>

                            <div className="pobotnica-tableRow pobotnica-tableRowTotal">
                                <div className="pobotnica-tableText">SKUPAJ</div>

                                <div className="pobotnica-tableTotalValue">
                                    {skupajZnesek.toLocaleString("sl-SI", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })}{" "}
                                    EUR
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="pobotnica-signatures">
                        <div className="pobotnica-signatureBlock">
                            <div className="pobotnica-signatureLabel">
                                Podpis stranke
                            </div>
                        </div>

                        <div className="pobotnica-signatureBlock">
                            <div className="pobotnica-signatureLabel">
                                Izvršitelj
                            </div>
                        </div>
                    </section>
                </div>

                <div className="pobotnica-bottomBar pobotnica-noPrint">
                    {pobotnicaSporocilo && (
                        <span className="pobotnica-bottomBarMessage">
                            {pobotnicaSporocilo}
                        </span>
                    )}

                    <button
                        type="button"
                        className="pobotnica-printBtn"
                        onClick={shraniPobotnico}
                        disabled={pobotnicaShranjevanje}
                    >
                        {pobotnicaShranjevanje
                            ? "Shranjujem…"
                            : "Shrani pobotnico"}
                    </button>

                    <button
                        type="button"
                        className="pobotnica-printBtn"
                        onClick={shraniPdf}
                        disabled={pdfShranjevanje}
                    >
                        {pdfShranjevanje ? "Shranjujem PDF…" : "Shrani PDF"}
                    </button>

                    <button
                        type="button"
                        className="pobotnica-printBtn"
                        onClick={natisni}
                    >
                        Natisni pobotnico
                    </button>
                </div>
            </main>
        </div>
    );
};

export default Pobotnica;